import { render } from "./OtherMessage.vue?vue&type=template&id=6aa142aa"
import script from "./OtherMessage.vue?vue&type=script&lang=js"
export * from "./OtherMessage.vue?vue&type=script&lang=js"

import "./OtherMessage.vue?vue&type=style&index=0&id=6aa142aa&lang=less"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__